import React from "react";
import LookupAdmin, { ActiveChip } from "../../components/LookupAdmin";

const config = {
  title: "Categorias de Produto",
  subtitle: "Agrupam o catálogo. Servem de filtro na tela de Produtos e nas propostas.",
  endpoint: "/product-categories",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 6 },
    { name: "description", label: "Descrição", span: 6 },
    { name: "active", label: "Ativo", type: "boolean", defaultValue: true }
  ],
  columns: [
    { key: "name", label: "Nome" },
    { key: "description", label: "Descrição" },
    { key: "active", label: "Status", render: (s) => <ActiveChip active={s.active} /> }
  ]
};

const ProductCategories = () => <LookupAdmin config={config} />;

export default ProductCategories;
